<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "ButtonOpenFilter",
    props: {
        text: {
            type: String,
            required: true
        }
    }
});
</script>

<template>
    <button class="ButtonBase ButtonBase--primary ButtonOpenFilter">
        <span>{{ text }}</span>
    </button>
</template>